import styled from "../styled";

export const StyledNavItems = styled.div`
    width: 90%;
    height: 100%;
    max-width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: var(--content-max-width);
`;
